import './Whatsapp.css';

function Whatsapp() {
    return (
        <div className='whatsapp-container'>
            <h1 className='whatsapp-title'>WhatsApp</h1>

            <p>
                Scrivici direttamente su WhatsApp scegliendo il numero giusto in base a ciò che vuoi inviarci:
            </p>

            <ul className='whatsapp-list'>
                <li>
                    <span className='whatsapp-contact-title'>Richieste e dediche</span>
                    <a href="https://wa.me/393489935038" target='_blank' rel="noreferrer">
                        +39 348 993 5038
                    </a>
                </li>
                <li>
                    <span className='whatsapp-contact-title'>Videomessaggi</span>
                    <a href="https://wa.me/393514613151" target='_blank' rel="noreferrer">
                        +39 351 461 3151
                    </a>
                </li>
            </ul>
        </div>
    );
}

export default Whatsapp;
